import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchLoginState, clickLogout } from './redux/auth/actions/auth';
const { detect } = require('detect-browser');
// CSS 
import './NavBar.css';

// Views
// import ModulePreview from './Views/Temp';
import LoginView from './Views/LoginView';
import ActivateView from './Views/ActivateView';
import DashboardView from './Views/DashboardView';
import ResetPasswordView from './Views/ResetPasswordView';

// Services 
import { globalService } from './Services/globalService.js';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

class NavBar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      userId: null,
      authenticated: false,
      user: null,
      submissionDueDate: null
    };

    this.setDataModel = this.setDataModel.bind(this);
    this.populateData = this.populateData.bind(this);
    //this.getCurrentPeriod();
  }

  componentDidMount() {
    this.populateData();
  }

  populateData() {
    this.setState({
      error: false,
      errorMessage: null
    });

    if (window.localStorage.FujairahAppStorage) {
      var user = JSON.parse(window.localStorage.getItem('FujairahAppStorage'));
      if (user) {
        this.setState({
          authenticated: true,
          user: user
        });
      } else {
        this.setState({
          authenticated: false,
          user: null
        });
      }
    }
  }

  displayError(error) {
    this.setState({
      error: true,
      errorMessage: error.message
    });
  }

  setDataModel(result, query) {
    const { data } = this.state;
    data['commodity'] = result;

    this.setState({
      data: result,
      isLoading: false
    });
  }

  getCurrentPeriod() {
    globalService.getCurrentPeriod().then((response) => {
      console.log(response);
    });
  }

  // Cognito Auth 
  componentWillMount() {
    const { pathname } = document.location;
    this.props.dispatch(fetchLoginState({ pathname: pathname }));
  }

  componentWillReceiveProps(nextProps) {
    const { auth } = nextProps;
    if (auth) {
      this.guestWillTransfer(auth);
    }
  }

  guestWillTransfer(auth) {
    const { pathname } = document.location;

    // if (!auth.isLoggedIn && (pathname.indexOf('/temp') !== -1)) {
    //   return
    // }
    if (!auth.isLoggedIn && pathname === '/temp') {
      this.transferPage('/login', 0);
      return;
    }
    if (pathname === '/logout') {
      auth.isLoggedIn = false;
      this.props.dispatch(clickLogout());
      this.transferPage('/login', 0);
      return;
    }

    if (!auth.isLoggedIn && (pathname.indexOf('/activate') !== -1)) {
      return;
    } else if (pathname === '/reset') {
      return;
    } else if (!auth.isLoggedIn && pathname !== '/login') {
      this.transferPage('/login', 0);
    } else if (auth.isLoggedIn && (pathname === '/login' || (pathname.indexOf('/activate') !== -1))) {
      this.transferPage('/', 0);
    }
  }

  transferPage(path, time) {
    setTimeout(function () {
      document.location.href = path;
    }, time);
  }

  render() {
    const { auth } = this.props;
    const browser = detect();
    let modulePreviewElement = null;

    if (process.env.NODE_ENV !== 'production') {
      // const ModulePreview = require('./Views/Temp').default;
      const ModulePreviewModule = require('./Views/Temp');
      const ModulePreview = ModulePreviewModule.default || ModulePreviewModule;
      modulePreviewElement = <ModulePreview />;
    }

    return (
      <div className="mainContainer">
        {
          (browser && browser.name === 'ie') ?
            <div className="browser-notification"><span>Unfortunately Internet Explorer is not supported. Please try using another browser.</span></div>
            :
            <div>
              <Routes>
                {/* <Route path="/temp" exact element={<ModulePreview />} /> */}
                {process.env.NODE_ENV !== 'production' ? <Route path="/temp" exact element={modulePreviewElement} /> : null}
                <Route path="/activate/:emailId" exact element={<ActivateView />} />
                <Route path="/reset" exact element={<ResetPasswordView />} />
                <Route path="/login" exact element={<LoginView />} />
                {/* OLD CODE - COMMENTED OUT FOR REMEDIATION */}
                {/* <Route path="/" exact element={<DashboardView control={this.props.auth.user !== undefined ? this.props.auth.user["custom:organisationType"] : null} />} /> */}
                {/* <Route path="/publisher/publishdate" exact element={<DashboardView control="publishdate" />} /> */}
                {/* <Route path="/submission/history" exact element={<DashboardView control="submissionhistory" />} /> */}
                {/* {this.props.auth.user !== undefined && this.props.auth.user['custom:admin'] !== null && this.props.auth.user['custom:admin'] === '0' ? <Route path="/admin/users" exact element={<DashboardView />} /> : null} */}
                {/* {this.props.auth.user !== undefined && this.props.auth.user['custom:admin'] !== null && this.props.auth.user['custom:admin'] === '1' ? <Route path="/admin/users" exact element={<DashboardView control="admin" manageUsers={true} />} /> : null} */}
                {/* <Route path="/admin/capacity" exact element={this.props.auth.user !== undefined && this.props.auth.user['custom:admin'] !== null && this.props.auth.user['custom:organisationType'] === 'operator' && this.props.auth.user['custom:admin'] === '1' ? <DashboardView control="admin" manageUsers={false} /> : <DashboardView />} /> */}
                {/* NEW CODE - WITH isLoggedIn CHECKS */}
                <Route path="/" exact element={<DashboardView control={this.props.auth.isLoggedIn && this.props.auth.user !== undefined ? this.props.auth.user["custom:organisationType"] : null} />} />
                {/* control is only set once auth.user exists, so the fetching sub-view can't mount before the restored auth token is available */}
                <Route path="/publisher/publishdate" exact element={this.props.auth.isLoggedIn && this.props.auth.user !== undefined ? <DashboardView control="publishdate" /> : <DashboardView />} />
                <Route path="/submission/history" exact element={this.props.auth.isLoggedIn && this.props.auth.user !== undefined ? <DashboardView control="submissionhistory" /> : <DashboardView />} />
                {this.props.auth.isLoggedIn && this.props.auth.user !== undefined && this.props.auth.user['custom:admin'] !== null && this.props.auth.user['custom:admin'] === '0' ? <Route path="/admin/users" exact element={<DashboardView />} /> : null}
                {this.props.auth.isLoggedIn && this.props.auth.user !== undefined && this.props.auth.user['custom:admin'] !== null && this.props.auth.user['custom:admin'] === '1' ? <Route path="/admin/users" exact element={<DashboardView control="admin" manageUsers={true} />} /> : null}
                <Route path="/admin/capacity" exact element={this.props.auth.isLoggedIn && this.props.auth.user !== undefined && this.props.auth.user['custom:admin'] !== null && this.props.auth.user['custom:organisationType'] === 'operator' && this.props.auth.user['custom:admin'] === '1' ? <DashboardView control="admin" manageUsers={false} /> : <DashboardView />} />
              </Routes>
            </div>}
      </div>
    );
  }
}

NavBar.propTypes = propTypes;

function select({ auth }) {
  return { auth };
}

export default connect(select)(NavBar);
